<template>
  <div id="page">
    <div class="home-carousel">
      <carousel :perPage="1" :autoplay="true" :autoplayTimeout="6000" :paginationSize="12" :paginationActiveColor="'#a67c52'">
        <slide v-for="(banner, key) in banners" v-bind:key="key">
          <a v-bind:href="banner.link" v-if="banner.link">
            <picture>
              <source media="(min-width: 992px)" v-bind:srcset="media_path + banner.path + banner.img_lg">
              <source media="(min-width: 768px)" v-bind:srcset="media_path + banner.path + banner.img_md">
              <img v-bind:src="media_path + banner.path + banner.img_sm" class="d-block img-fluid m-auto w-100" alt="">
            </picture>
          </a>
          <picture v-if="!banner.link">
            <source media="(min-width: 992px)" v-bind:srcset="media_path + banner.path + banner.img_lg">
            <source media="(min-width: 768px)" v-bind:srcset="media_path + banner.path + banner.img_md">
            <img v-bind:src="media_path + banner.path + banner.img_sm" class="d-block img-fluid m-auto w-100" alt="" v-if="!banner.link">
          </picture >
        </slide>
      </carousel>
    </div>
    <div id="breadcrumb-wrapper"></div>
    <div class="container" id="products">
      <h1 class="text-center mt-5">{{ title.product }}</h1>
      <div class="row justify-content-start justify-content-lg-center mt-3 mt-md-5">
        <div class="col-12 col-lg-10">
          <div class="row d-md-none">
            <div class="col-12">
              <select class="form-control" v-on:change="goSelectCate()" v-model="currentCat">
                <option v-bind:value="item.keyword" v-for="(item, key) in categories" v-bind:key="key" v-bind:lavue="item.keyword">{{ item.name }}</option>
              </select>
            </div>
          </div>
          <div class="row d-none d-md-flex">
            <div class="col-4 col-lg mb-4" v-for="(item, key) in categories" v-bind:key="key">
              <a href="#" class="category-filter d-flex align-items-center justify-content-lg-center" v-bind:class="{ active: item.keyword === currentCat }" v-on:click="goCate(item.keyword, $event)">
                <div class="icon-filter d-flex justify-content-center align-items-center">
                  <i v-bind:class="item.icon"></i>
                </div>
                {{ item.name }}
              </a>
            </div>
          </div>

          <transition name="fade">
            <div class="row mt-4 mt-md-5 mb-3" v-if="!productLoaded">
              <div class="col-12">
                <div class="product-loading d-flex align-items-center justify-content-center">
                  <div class="spinner">
                    <div class="double-bounce1"></div>
                    <div class="double-bounce2"></div>
                  </div>
                </div>
              </div>
            </div>
          </transition>

          <transition name="fade">
            <div class="row mt-4 mt-md-5 mb-3" v-if="productLoaded">
              <div class="col-12 col-md-4" v-for="(product, key) in products" v-bind:key="key">
                <router-link :to="{ name: 'Product', params: { id: product.id, slug: slugGenerator(product.product_name) } }">
                  <div class="product-item">
                    <div class="product-thumbnail">
                      <div class="product-media" v-bind:style="{backgroundImage: 'url(' + media_path + product.path + product.img_sm + ')'}"></div>
                    </div>
                    <div class="product-desc">
                      <div class="product-name text-center">{{ product.product_name }}</div>
                      <div class="product-volume text-center">{{ product.product_size }}</div>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
          </transition>
        </div>
      </div>

      <nav aria-label="Page navigation product" class="mb-5" v-if="productLoaded">
        <ul class="pagination justify-content-center">
          <li class="page-item" v-bind:class="{ active: currentPage === key + 1 }" v-for="(paginaion, key) in totalPage" v-bind:key="key"><a class="page-link" v-on:click="goPage(key+1, $event)" v-scroll-to="'#products'">{{ key + 1 }}</a></li>
        </ul>
      </nav>
    </div>
    <transition name="fade">
      <div class="loading-overlay d-flex align-items-center justify-content-center" v-if="!pageLoaded">
        <div class="spinner">
          <div class="double-bounce1"></div>
          <div class="double-bounce2"></div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Home',
  data () {
    return {
      pageLoaded: false,
      productLoaded: false,
      lang: this.$router.history.current.params.lang,
      banners: [],
      products: [],
      currentPage: 1,
      totalPage: null,
      currentCat: '',
      title: {
        product: ''
      },
      categories: [],
      media_path: process.env.MEDIA_PATH
    }
  },
  created () {
    this.getbanner()
    this.getproducts()

    if (this.lang === 'th') {
      document.title = 'เคฟู๊ด อิมปอร์ต เอ็กซ์ปอร์ต จำกัด'
      this.title = {
        product: 'สินค้าของเรา'
      }
      this.categories = [
        {
          name: 'สินค้าทั้งหมด',
          keyword: '',
          icon: 'icon-cog'
        }
      ]
    } else {
      document.title = 'K Food Import Export Co., Ltd.'
      this.title = {
        product: 'Our products'
      }
      this.categories = [
        {
          name: 'All products',
          keyword: '',
          icon: 'icon-cog'
        }
      ]
    }

    this.getcategories()
  },
  methods: {
    getbanner () {
      let self = this
      axios.get(process.env.API_PATH + '/banners').then((response) => {
        self.pageLoaded = true
        self.banners = response.data.result
      }).catch((error) => {
        console.log(error)
      })
    },
    getcategories () {
      let self = this
      axios.get(process.env.API_PATH + '/getcategories', {
        params: {
          lang: self.lang
        }
      }).then((response) => {
        for (let i = 0; i < response.data.result.length; i++) {
          let cat = {
            name: response.data.result[i].category_name,
            keyword: response.data.result[i].slug,
            icon: response.data.result[i].icon
          }
          self.categories.push(cat)
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    getproducts () {
      let self = this
      self.productLoaded = false
      axios.get(process.env.API_PATH + '/product', {
        params: {
          cate: self.currentCat,
          page: self.currentPage,
          lang: self.lang
        }
      }).then((response) => {
        self.products = response.data.result
        self.totalPage = response.data.totalPage
        self.productLoaded = true
      })
    },
    goPage (page, e) {
      e.preventDefault()
      this.currentPage = page
      this.getproducts()
    },
    goCate (cate, e) {
      e.preventDefault()
      this.currentPage = 1
      this.currentCat = cate
      this.getproducts()
    },
    goSelectCate () {
      this.currentPage = 1
      this.getproducts()
    },
    slugGenerator (val) {
      // eslint-disable-next-line no-useless-escape
      return val.toLowerCase().trim().replace(/([~!@#$%^&*()_+=`{}\[\]\|\\:;'"<>,.\/? ])+/g, '-')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Home.vue